import {useState} from "react";
import {ConfirmationDialog} from "../../../../components/composite/ConfirmationDialog/ConfirmationDialog.jsx";
import {InfoDialog} from "../../../../components/composite/InfoDialog/InfoDialog.jsx";
import {Dialog} from "../../../../components/base/Dialog/Dialog.jsx";
import {Button} from "../../../../components/base/Button/Button.jsx";
import {ShowcaseLayout} from "../../layout/ShowcaseLayout.jsx";

export const TestDialogs = () => {
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [showCustom, setShowCustom] = useState(false);

    const handleConfirm = () => {
        alert("Confirmed!");
        setShowConfirmation(false);
    };

    return (
        <ShowcaseLayout>
            <h2>Test Dialogs</h2>
            
            <Button onClick={() => setShowConfirmation(true)}>
                Show Confirmation Dialog
            </Button>
            
            <Button onClick={() => setShowInfo(true)}>
                Show Info Dialog
            </Button>
            
            <Button onClick={() => setShowCustom(true)}>
                Show Custom Dialog
            </Button>
            
            {showConfirmation && (
                <ConfirmationDialog
                    title="Confirm Action"
                    description="Are you sure you want to proceed with this action?"
                    onClose={() => setShowConfirmation(false)}
                    action={handleConfirm}
                    confirmBtnText="Confirm"
                    cancelBtnText="Cancel"
                />
            )}
            
            {showInfo && (
                <InfoDialog
                    title="Information"
                    description="This is an informational dialog that displays important messages to the user."
                    onClose={() => setShowInfo(false)}
                />
            )}
            
            {showCustom && (
                <Dialog
                    title="Custom Dialog"
                    onClose={() => setShowCustom(false)}
                >
                    <p>This is a custom dialog using the base Dialog component. You can add any content here for custom use cases.</p>
                    <Button onClick={() => setShowCustom(false)}>
                        Close
                    </Button>
                </Dialog>
            )}
        </ShowcaseLayout>
    );
};